import React from 'react';
import { ApprovalLevelsDisplay } from '../sections';

interface RefundConfigTabProps {
  centerId: string;
  initialConfig: any; // You might want to define a proper RefundApprovalConfig type
}

export const RefundConfigTab: React.FC<RefundConfigTabProps> = ({
  centerId,
  initialConfig
}) => {
  return (
    <ApprovalLevelsDisplay
      centerId={centerId}
      initialConfig={initialConfig}
    />
  );
};